<template>
  <validation-observer ref="simpleRules">
    <b-form
      class="auth-reset-password-form mt-2"
      @submit.prevent="validationForm"
    >
      <b-form-group label-for="email" class="w-100" label="Email">
        <validation-provider
          #default="{ errors }"
          name="Email"
          rules="required|email"
        >
          <b-form-input
            id="email"
            v-model="email"
            name="email"
            :disabled="mode == 'sent'"
            placeholder="johndoe@example.com"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        label-for="code"
        class="w-100"
        label="Code"
        v-if="mode == 'sent'"
      >
        <validation-provider
          #default="{ errors }"
          name="Code"
          rules="required|min:6"
        >
          <b-form-input
            id="code"
            v-model="code"
            name="code"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <div class="text-right mb-50" v-if="mode == 'sent'">
        <b-link class="text-muted" @click="mode = 'change'">
          <small>Wrong Email?</small>
        </b-link>
      </div>
      <b-button block type="button" @click="resend" v-if="mode == 'sent'">
        Resend
      </b-button>
      <b-button block type="submit" class="gradient-btn">
        {{ mode == "change" ? "send" : "Set New Email" }}
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import { required } from "@validations";
import Loader from "@/@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  data() {
    return {
      email: "",
      code: "",
      mode: "change",
      loading: false,
      // validation
      required,
    };
  },

  methods: {
    async resend() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          "/panel/profile/user/resend-email",
          {
            email: this.email,
          }
        );
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Code sent successfully`,
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
      } catch (error) {}
      this.loading = false;
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.mode == "change") {
              const { data } = await this.$http.post(
                "/panel/profile/user/change-email",
                {
                  email: this.email,
                }
              );
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Code sent successfully`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              });
              this.mode = "sent";
            } else {
              const { data } = await this.$http.post(
                "/panel/profile/user/verify",
                {
                  email: this.email,
                  code: this.code,
                }
              );
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Email Changed successfully`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              });
              this.$emit("emailChanged");
              this.mode = "change";
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
